export function renderShell(root) {
  root.innerHTML = `
    <s-page heading="POD Studio" inline-size="large">
      <div class="app-tabs" role="tablist" aria-label="POD Studio">
        <button id="tab-creator" class="tab is-active" data-tab="creator" role="tab" aria-selected="true" aria-controls="creator-panel" tabindex="0">Product creator</button>
        <button id="tab-apparel" class="tab" data-tab="apparel" role="tab" aria-selected="false" aria-controls="apparel-panel" tabindex="-1">Apparel batch</button>
        <button id="tab-fulfillment" class="tab" data-tab="fulfillment" role="tab" aria-selected="false" aria-controls="fulfillment-panel" tabindex="-1">Fulfillment</button>
      </div>
      <main id="creator-panel" class="panel" role="tabpanel" aria-labelledby="tab-creator">
        <div class="creator-grid">
          <section class="preview-card" aria-label="Mockup preview">
            <div class="preview-heading">
              <div><span class="step">Preview</span><h2 id="preview-name">Product mockup</h2></div>
              <select id="preview-color" aria-label="Preview color"></select>
            </div>
            <canvas id="mockup-canvas" width="1200" height="1200"></canvas>
            <div class="placement-controls">
              <label>Scale <input id="design-scale" type="range" min="35" max="120" value="82"></label>
              <label>Horizontal <input id="design-x" type="range" min="-12" max="12" value="0"></label>
              <label>Vertical <input id="design-y" type="range" min="-14" max="14" value="0"></label>
            </div>
          </section>
          <section class="settings-card">
            <div class="form-section">
              <span class="step">1 · Artwork</span>
              <label class="field">Design PNG
                <input id="design-file" type="file" accept="image/png">
              </label>
              <p class="hint">Transparent PNG recommended. Front print only in this MVP.</p>
            </div>
            <div class="form-section">
              <span class="step">2 · Production template</span>
              <label class="field">Blank
                <select id="template-select"></select>
              </label>
              <fieldset><legend>Colors</legend><div id="color-options" class="choice-grid"></div></fieldset>
              <fieldset><legend>Sizes</legend><div id="size-options" class="choice-grid"></div></fieldset>
            </div>
            <div class="form-section">
              <span class="step">3 · Listing</span>
              <label class="field">Product title<input id="product-title" type="text" maxlength="120"></label>
              <label class="field">Product description<input id="product-description" type="text" maxlength="500" placeholder="Describe the artwork and why customers may like it"></label>
              <label class="field">Retail price (USD)<input id="product-price" type="number" min="1" step="0.01"></label>
              <label class="field">Compare-at price (USD)<input id="product-compare-at-price" type="number" min="1" step="0.01" placeholder="Optional — must be higher than retail price"></label>
            </div>
            <div class="publish-footer">
              <p id="variant-summary" class="hint"></p>
              <button id="publish-button" class="primary-button" type="button">Publish to Shopify</button>
              <div id="publish-status" class="status" aria-live="polite"></div>
            </div>
          </section>
        </div>
      </main>
      <main id="apparel-panel" class="panel" role="tabpanel" aria-labelledby="tab-apparel" hidden>
        <section class="batch-card" aria-labelledby="catalog-setup-heading">
          <div class="section-heading"><div><span class="step">Storefront catalog</span><h2 id="catalog-setup-heading">Set up collections and navigation</h2><p class="hint">Creates tag-based collections for the current catalog and replaces the main menu. Products join automatically when Printify publishes them with their product-type tag.</p></div><button id="setup-storefront-catalog" class="primary-button compact-button" type="button">Set up storefront catalog</button></div>
          <div id="catalog-setup-status" class="status" aria-live="polite"></div>
        </section>
        <section class="batch-card">
          <div class="section-heading"><div><span class="step">US catalog</span><h2>One design, seven Printify listings</h2><p class="hint">Create setup drafts once to capture masters. Later, upload one design and create drafts from those locked master templates.</p></div></div>
          <div class="batch-fields">
            <label class="field">Design PNG<input id="apparel-design-file" type="file" accept="image/png"></label>
            <label class="field">Design name<input id="apparel-title" type="text" maxlength="92" placeholder="e.g. Moonlight Raccoon"></label>
            <label class="field">Connected Printify shop<select id="apparel-shop" aria-label="Connected Printify shop"></select></label>
          </div>
          <div id="apparel-masters" class="apparel-masters"><p class="empty-state compact">Loading saved master templates…</p></div>
          <div class="batch-actions"><button id="create-drafts-from-masters" class="primary-button compact-button" type="button" disabled>Create from saved masters</button></div>
          <details class="setup-drafts"><summary>Create or update setup drafts</summary><p class="hint">Use only when you need to establish or replace a master. Adjust the resulting draft in Printify, then save it as a master below.</p><div id="apparel-routes" class="apparel-routes"><p class="empty-state compact">Loading current Printify US routes…</p></div><div class="batch-actions"><button id="create-apparel-drafts" class="secondary-button compact-button" type="button" disabled>Create selected setup drafts</button></div></details>
          <div id="apparel-status" class="status" aria-live="polite"></div>
        </section>
        <section class="batch-card" aria-labelledby="apparel-draft-heading">
          <div><span class="step">Review</span><h2 id="apparel-draft-heading">Drafts ready to publish</h2></div>
          <div id="apparel-drafts" class="empty-state compact">No batch drafts created in this session.</div>
        </section>
        <section class="batch-card" aria-labelledby="apparel-metadata-heading">
          <div><span class="step">Metadata</span><h2 id="apparel-metadata-heading">Generate and apply listing metadata</h2><p class="hint">Generate US-English metadata from the original PNG and Design name. GPT-5.6 Luna applies it to every draft; publishing stays under your control.</p></div>
          <div id="apparel-metadata" class="empty-state compact">Create a batch draft to generate metadata.</div>
        </section>
      </main>
      <main id="fulfillment-panel" class="panel" role="tabpanel" aria-labelledby="tab-fulfillment" hidden>
        <section class="integration-card">
          <div><span class="step">Operating mode</span><h2>Manual fulfillment decision console</h2></div>
          <div id="integration-status" class="status">Checking backend…</div>
        </section>
        <section class="fulfillment-card">
          <div class="section-heading"><div><span class="step">Paid orders</span><h2>Provider decisions and shipment groups</h2><p class="hint">The app recommends and records a route. It never submits production orders.</p></div><button id="refresh-fulfillments" class="secondary-button">Refresh</button></div>
          <div id="fulfillment-list" class="empty-state">No fulfillment groups require attention.</div>
        </section>
      </main>
    </s-page>`;
}

export function renderApparelRoutes(root, routes) {
  const available = routes.filter(({available}) => available);
  root.innerHTML = routes.map((route) => route.available ? `
    <label class="apparel-route">
      <input type="checkbox" name="apparel-route" value="${escapeHtml(route.group)}" checked>
      <span><strong>${escapeHtml(route.label)}</strong><small>${escapeHtml(route.blueprintTitle)} · ${escapeHtml(route.printProviderTitle)}</small><small>${escapeHtml(route.variantCount)} US-ready variants · score ${escapeHtml(route.score)}</small></span>
    </label>` : `
    <article class="apparel-route apparel-route--unavailable"><strong>${escapeHtml(route.label)}</strong><small>${escapeHtml(route.reason || 'No compatible route available.')}</small></article>`).join('')
    || '<p class="empty-state compact">No compatible apparel routes are available from Printify right now.</p>';
  return available.length;
}

export function renderApparelDrafts(root, drafts, metadata = null, masters = []) {
  if (!drafts.length) {
    root.className = 'empty-state compact';
    root.textContent = 'No batch drafts created in this session.';
    return;
  }
  root.className = 'apparel-drafts';
  root.innerHTML = `${drafts.map((draft) => {
    const master = masters.find(({group, sourceProductId}) => group === draft.group && sourceProductId === draft.productId);
    return `<article class="apparel-draft"><label><input type="checkbox" name="apparel-draft" value="${escapeHtml(draft.productId)}" checked><span><strong>${escapeHtml(draft.label)}</strong><small>${escapeHtml(draft.title)}</small><small>Printify ID: ${escapeHtml(draft.productId)}</small>${draft.masterVersion ? `<small>Master v${escapeHtml(draft.masterVersion)}</small>` : ''}${metadata?.ready && draft.metadataVersionApplied === metadata.version ? '<small class="metadata-applied">Current metadata applied</small>' : '<small>Metadata not applied</small>'}</span></label><button class="secondary-button compact-button" type="button" data-action="capture-master" data-product-id="${escapeHtml(draft.productId)}">${master ? `Update master v${escapeHtml(master.version)}` : 'Save as master'}</button></article>`;
  }).join('')}
    <button id="publish-selected-apparel" class="primary-button compact-button" type="button" ${metadata?.ready ? '' : 'disabled'}>Publish selected</button>`;
}

export function renderCatalogMasters(root, masters) {
  const configured = masters.filter(({configured}) => configured).length;
  root.className = 'apparel-masters';
  root.innerHTML = `${masters.map((master) => master.configured ? `
    <label class="master-card"><input type="checkbox" name="catalog-master" value="${escapeHtml(master.group)}" checked><span><strong>${escapeHtml(master.label)}</strong><small>Master v${escapeHtml(master.version)} · ${escapeHtml(master.variantCount)} variants</small><small>${escapeHtml(master.sourceTitle || `Printify source ${master.sourceProductId}`)}</small></span></label>` : `
    <article class="master-card master-card--missing"><strong>${escapeHtml(master.label)}</strong><small>Not configured. Create a setup draft, adjust it in Printify, then save it as a master.</small></article>`).join('')}
    <p class="master-summary">${configured}/7 master templates ready</p>`;
  return configured;
}

export function renderApparelMetadata(root, batch) {
  const metadata = batch?.metadata;
  if (!batch) {
    root.className = 'empty-state compact';
    root.textContent = 'Create a batch draft to generate metadata.';
    return;
  }
  root.className = 'metadata-panel';
  const state = metadata?.ready ? `Generated and validated ${escapeHtml(metadata.generatedAt || metadata.reviewedAt || '')}` : 'Not generated — publish is blocked.';
  root.innerHTML = `
    <div class="metadata-source"><div><strong>Metadata source: original PNG + Design name</strong><small>Model: GPT-5.6 Luna · US English</small></div><a class="secondary-button button-link compact-button" href="https://printify.com/app/products" target="_blank" rel="noopener noreferrer">Open Printify drafts</a></div>
    <div class="metadata-actions"><button id="generate-apparel-metadata" class="primary-button compact-button" type="button">${metadata ? 'Regenerate metadata' : 'Generate metadata'}</button><span class="hint">Generation updates all drafts in this batch. It never publishes a listing.</span></div>
    <span class="metadata-state ${metadata?.ready ? 'metadata-state--ready' : ''}">${state}</span>
    ${metadata ? `<form id="apparel-metadata-form" class="metadata-form">
      <div class="metadata-fields">
        <label class="field">Base title<input name="baseTitle" type="text" maxlength="92" value="${escapeHtml(metadata.baseTitle)}" required></label>
        <label class="field">Tags (comma separated)<input name="tags" type="text" maxlength="1200" value="${escapeHtml((metadata.tags || []).join(', '))}" required></label>
        <label class="field wide-field">Description (HTML allowed)<textarea name="descriptionHtml" maxlength="10000" required>${escapeHtml(metadata.descriptionHtml || '')}</textarea></label>
        <label class="field">SEO title<input name="seoTitle" type="text" maxlength="70" value="${escapeHtml(metadata.seoTitle)}" required></label>
        <label class="field">SEO description<input name="seoDescription" type="text" maxlength="160" value="${escapeHtml(metadata.seoDescription)}" required></label>
        <label class="field">URL handle suggestion<input name="handleSuggestion" type="text" maxlength="120" value="${escapeHtml(metadata.handleSuggestion)}" required></label>
        <label class="field">Mockup alt text<input name="altText" type="text" maxlength="160" value="${escapeHtml(metadata.altText)}" required></label>
      </div>
      <label class="metadata-confirmation"><input name="reviewConfirmed" type="checkbox" required><span>I reviewed this copy for accuracy, rights and unverified claims. Saving reapplies the revised metadata to every draft.</span></label>
      <button class="primary-button compact-button" type="submit">Save and apply revised metadata</button>
      <div class="metadata-preview"><strong>Per-listing title format</strong>${batch.products.map((product) => `<span>${escapeHtml(`${metadata.baseTitle} — ${product.label}`.slice(0, 120))}</span>`).join('')}</div>
    </form>` : ''}`;
}

export function renderTemplateSelect(select, templates, selectedKey) {
  select.innerHTML = templates.map((template) => `
    <option value="${escapeHtml(template.key)}" ${template.key === selectedKey ? 'selected' : ''}>
      ${escapeHtml(template.name)}
    </option>`).join('');
}

export function renderChoices(root, name, values, selected) {
  root.innerHTML = values.map((value) => `
    <label class="choice ${selected.has(value) ? 'is-selected' : ''}">
      <input type="checkbox" name="${name}" value="${escapeHtml(value)}" ${selected.has(value) ? 'checked' : ''}>
      ${escapeHtml(value)}
    </label>`).join('');
}

export function renderPreviewColors(select, colors, current) {
  select.innerHTML = colors.map((color) => `
    <option value="${escapeHtml(color)}" ${color === current ? 'selected' : ''}>${escapeHtml(color)}</option>`).join('');
}

export function renderFulfillments(root, groups, legacyOrders = []) {
  if (!groups.length && !legacyOrders.length) {
    root.className = 'empty-state';
    root.textContent = 'No fulfillment groups require attention.';
    return;
  }
  root.className = 'fulfillment-groups';
  root.innerHTML = `${groups.map(fulfillmentGroupMarkup).join('')}${legacyOrders.length ? `
    <section class="legacy-orders" aria-label="Legacy Mango fulfillment records">
      <div><span class="step">Legacy records</span><h3>Earlier Mango fulfillment activity</h3></div>
      ${legacyOrders.map(legacyOrderMarkup).join('')}
    </section>` : ''}`;
}

function legacyOrderMarkup(order) {
  return `<article class="legacy-order">
    <div><strong>${escapeHtml(order.shopify_order_name || 'Shopify order')}</strong><span>${escapeHtml(order.mango_order_id || 'No Mango order ID')}</span></div>
    <span class="order-status order-status--${escapeClass(order.status)}">${escapeHtml(humanize(order.status))}</span>
    <span>${escapeHtml(order.tracking_number || 'No tracking recorded')}</span>
  </article>`;
}

export function fulfillmentGroupMarkup(input) {
  const group = normalizeGroup(input);
  const selectedQuote = group.decision.quoteId;
  const candidateMarkup = group.candidates.length
    ? group.candidates.map((candidate) => candidateCardMarkup(group, candidate, selectedQuote)).join('')
    : '<p class="empty-state compact">No eligible provider quote is available. Hold or refund this group.</p>';
  const locked = Boolean(group.decision.lockedAt || group.providerOrderId);
  const selectedCandidate = group.lockedCandidate
    || group.candidates.find(({quoteId}) => quoteId === selectedQuote);
  const portalAccess = Boolean(group.providerOrderId)
    || (group.status === 'provider-submitting' && group.submissionLeaseStatus === 'authorized');
  const payloadObject = group.decision.copyPayload || group.copyPayload || {
    externalReference: group.externalReference,
    shopifyOrder: group.orderName,
    fulfillmentGroup: group.id,
    item: group.lineTitle,
    variant: group.variantTitle,
    listingSku: group.sku,
    quantity: group.quantity,
    provider: selectedCandidate?.provider,
    providerRoute: selectedCandidate?.routeKey,
    artworkReference: selectedCandidate?.artworkReference,
    previewEvidenceUrl: selectedCandidate?.previewEvidenceUrl,
  };
  const payload = portalAccess ? encodeURIComponent(JSON.stringify(payloadObject, null, 2)) : '';

  return `
    <article class="fulfillment-group" data-group-id="${escapeHtml(group.id)}">
      <header class="fulfillment-group__header">
        <div>
          <span class="step">${escapeHtml(group.orderName)} · Group ${escapeHtml(group.id)}</span>
          <h3>${escapeHtml(group.lineTitle)}</h3>
          <p class="hint">${escapeHtml(group.variantTitle)} · Qty ${escapeHtml(group.quantity)} · ${escapeHtml(group.market)}</p>
          <p class="hint">Printify listing SKU: ${escapeHtml(group.sku || 'not supplied by Shopify')}</p>
        </div>
        <span class="order-status order-status--${escapeClass(group.status)}">${escapeHtml(humanize(group.status))}</span>
      </header>
      <div class="candidate-grid" role="radiogroup" aria-label="Provider route for ${escapeHtml(group.lineTitle)}">
        ${candidateMarkup}
      </div>
      <div class="decision-actions">
        <button class="primary-button compact-button" type="button" data-action="lock-provider" data-group-id="${escapeHtml(group.id)}" ${!selectedQuote || locked ? 'disabled' : ''}>
          ${locked ? 'Provider decision locked' : 'Lock selected provider'}
        </button>
        <button class="secondary-button" type="button" data-action="refresh-candidates" data-group-id="${escapeHtml(group.id)}" ${locked ? 'disabled' : ''}>Refresh quotes</button>
        <button class="secondary-button" type="button" data-action="copy-payload" data-payload="${escapeHtml(payload)}" ${portalAccess ? '' : 'disabled'}>Copy order payload</button>
        ${portalAccess ? safeLink(selectedCandidate?.deepLink || group.decision.deepLink || group.deepLink) : ''}
        ${locked && !group.providerOrderId && group.status === 'provider-selected' ? `<button class="primary-button compact-button" type="button" data-action="claim-submission" data-group-id="${escapeHtml(group.id)}">Claim exclusive submission lease</button>` : ''}
      </div>
      ${locked ? fulfillmentRecordMarkup(group) : '<p class="hint decision-hint">Lock a qualified route before creating the order manually in the provider portal.</p>'}
    </article>`;
}

function candidateCardMarkup(group, candidate, selectedQuote) {
  const disabled = !candidate.eligible || group.decision.lockedAt || group.providerOrderId;
  const checked = candidate.quoteId === selectedQuote;
  const reasons = candidate.reasons.length
    ? `<ul>${candidate.reasons.map((reason) => `<li>${escapeHtml(reason)}</li>`).join('')}</ul>`
    : '';
  return `
    <label class="candidate-card ${checked ? 'is-selected' : ''} ${candidate.eligible ? '' : 'is-ineligible'}">
      <span class="candidate-card__select">
        <input type="radio" name="provider-${escapeHtml(group.id)}" value="${escapeHtml(candidate.quoteId)}" data-route-id="${escapeHtml(candidate.routeId)}" data-action="select-provider" data-group-id="${escapeHtml(group.id)}" ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}>
        <strong>${escapeHtml(candidate.provider)}</strong>
        ${candidate.recommended ? '<span class="recommendation-badge">Recommended</span>' : ''}
      </span>
      <span class="candidate-meta">${escapeHtml(candidate.productionCountry)} · ${escapeHtml(candidate.sla)} · ${escapeHtml(formatExpiry(candidate.expiresAt))}</span>
      <span class="candidate-metrics">
        <span><small>Total cost</small><strong>${escapeHtml(formatMoney(candidate.totalCost, candidate.currency))}</strong></span>
        <span><small>Margin</small><strong>${escapeHtml(formatPercent(candidate.margin))}</strong></span>
        <span><small>Score</small><strong>${escapeHtml(formatScore(candidate.score))}</strong></span>
        <span><small>Quality</small><strong>${escapeHtml(formatScore(candidate.qualityScore))}</strong></span>
      </span>
      <span class="candidate-flags">
        <span class="flag ${candidate.complianceEligible ? 'flag--success' : 'flag--neutral'}">${candidate.complianceEligible ? 'GPSR verified' : 'GPSR not verified'}</span>
        <span class="flag">${escapeHtml(candidate.confidence || 'Unverified data')}</span>
      </span>
      ${reasons}
    </label>`;
}

function fulfillmentRecordMarkup(group) {
  if (!group.providerOrderId) {
    if (group.status !== 'provider-submitting') {
      return '<p class="hint decision-hint">Claim the exclusive submission lease and pass the fresh Shopify state check before opening the provider portal.</p>';
    }
    return `
      <form class="fulfillment-record" data-form="external-order" data-group-id="${escapeHtml(group.id)}">
        <div><span class="step">Provider portal</span><h4>Create exactly one order manually, then record its ID</h4><p class="hint">The short-lived lease exists only in this browser session. If its outcome is ambiguous, stop and reconcile; never reclaim automatically.</p></div>
        <label class="field">Provider order ID<input name="providerOrderId" type="text" required maxlength="160" autocomplete="off"></label>
        <button class="primary-button compact-button" type="submit">Record external order</button>
      </form>`;
  }
  if (group.status === 'fulfilled') {
    return `<div class="fulfillment-record fulfillment-record--complete"><strong>Fulfilled</strong><span>${escapeHtml(group.providerOrderId)} · ${escapeHtml(group.trackingNumber || 'Tracking recorded')}</span></div>`;
  }
  return `
    <form class="fulfillment-record" data-form="tracking" data-group-id="${escapeHtml(group.id)}">
      <div><span class="step">Shipment</span><h4>Confirm tracking for this group only</h4><p class="hint">Provider order ${escapeHtml(group.providerOrderId)}</p></div>
      <label class="field">Carrier<input name="carrier" type="text" required maxlength="80"></label>
      <label class="field">Tracking number<input name="trackingNumber" type="text" required maxlength="160" autocomplete="off"></label>
      <label class="field">Tracking URL<input name="trackingUrl" type="url" maxlength="500" placeholder="https://"></label>
      <label class="confirmation"><input name="confirmed" type="checkbox" required> I confirmed this shipment and quantity in the provider portal.</label>
      <button class="primary-button compact-button" type="submit">Create Shopify fulfillment</button>
    </form>`;
}

function normalizeGroup(input) {
  const decision = input.decision || {};
  const candidates = (input.candidates || input.routes || []).map(normalizeCandidate);
  if (!candidates.some(({recommended}) => recommended)) {
    const ranked = candidates.filter(({eligible}) => eligible)
      .sort((left, right) => right.score - left.score || right.qualityScore - left.qualityScore);
    if (ranked[0]) ranked[0].recommended = true;
  }
  const preferred = candidates.find(({recommended, eligible}) => recommended && eligible)
    || candidates.find(({eligible}) => eligible);
  const selectedProvider = input.selectedProvider || input.selected_provider || '';
  return {
    id: input.id || input.group_id || input.fulfillment_group_id || '',
    orderName: input.orderName || input.shopifyOrderName || input.shopify_order_name || input.order_name || 'Shopify order',
    lineTitle: input.lineTitle || input.line_title || input.product_title || 'POD item',
    variantTitle: input.variantTitle || input.variant_title || input.variant || 'Variant',
    sku: input.sku || input.listingSku || input.listing_sku || '',
    quantity: input.quantity || 1,
    market: input.market || input.destination_market || input.country_code || 'US',
    externalReference: input.externalReference || input.external_reference || '',
    status: input.status || 'decision-required',
    candidates,
    decision: {
      quoteId: decision.quoteId || decision.quote_id || input.selectedQuoteId || input.selected_quote_id
        || (selectedProvider ? candidates.find(({provider}) => provider === selectedProvider)?.quoteId : '')
        || preferred?.quoteId || '',
      lockedAt: decision.lockedAt || decision.locked_at || input.decision_locked_at
        || (selectedProvider ? input.updatedAt || input.updated_at || 'locked' : ''),
      deepLink: decision.deepLink || decision.deep_link || '',
      copyPayload: decision.copyPayload || decision.copy_payload,
    },
    providerOrderId: input.providerOrderId || input.provider_order_id || '',
    lockedCandidate: input.lockedCandidate || input.locked_candidate || null,
    trackingNumber: input.trackingNumber || input.tracking_number || '',
    submissionLeaseStatus: input.submissionLeaseStatus || input.submission_lease_status || '',
    copyPayload: input.copyPayload || input.copy_payload,
    deepLink: input.deepLink || input.deep_link || '',
  };
}

function normalizeCandidate(input) {
  const costParts = [input.baseCost ?? input.base_cost, input.shippingCost ?? input.shipping_cost,
    input.paymentFee ?? input.payment_fee, input.merchantTaxDuty ?? input.merchant_tax_duty];
  const totalCost = input.totalCost ?? input.total_cost
    ?? costParts.reduce((sum, value) => sum + (Number(value) || 0), 0);
  return {
    quoteId: input.quoteId || input.quote_id || input.routeId || input.route_id || input.id || '',
    routeId: input.routeId || input.route_id || input.id || '',
    provider: input.provider || input.provider_name || 'Provider',
    productionCountry: input.productionCountry || input.production_country || 'Origin not verified',
    sla: input.sla || input.delivery_sla || (input.deliveryScore != null ? `Delivery score ${input.deliveryScore}/100` : 'SLA not verified'),
    totalCost,
    currency: input.currency || 'USD',
    margin: input.margin ?? input.contribution_margin,
    score: input.score ?? input.total_score,
    qualityScore: input.qualityScore ?? input.quality_score,
    confidence: input.confidence || input.data_confidence || (input.confidenceScore != null ? `Confidence ${input.confidenceScore}/100` : ''),
    complianceEligible: Boolean(input.complianceEligible ?? input.compliance_eligible ?? input.gpsrVerified ?? input.gpsr_verified),
    eligible: input.eligible !== false,
    recommended: Boolean(input.recommended),
    reasons: Array.isArray(input.reasons) ? input.reasons : [],
    expiresAt: input.expiresAt || input.expires_at || '',
  };
}

function formatMoney(value, currency) {
  const number = Number(value);
  if (!Number.isFinite(number)) return 'Pending quote';
  try { return new Intl.NumberFormat('en-US', {style: 'currency', currency}).format(number); }
  catch { return `${number.toFixed(2)} ${currency}`; }
}

function formatPercent(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return 'Pending';
  return `${(Math.abs(number) <= 1 ? number * 100 : number).toFixed(1)}%`;
}

function formatScore(value) {
  const number = Number(value);
  return Number.isFinite(number) ? `${number.toFixed(1)}/100` : 'Pending';
}

function formatExpiry(value) {
  if (!value) return 'Quote time missing';
  const timestamp = new Date(value);
  if (Number.isNaN(timestamp.getTime())) return 'Quote time invalid';
  return timestamp.getTime() <= Date.now()
    ? 'Quote expired'
    : `Valid until ${timestamp.toLocaleString('en-US', {dateStyle: 'short', timeStyle: 'short'})}`;
}

function humanize(value) {
  return String(value || '').replaceAll('-', ' ').replaceAll('_', ' ');
}

function escapeClass(value) {
  return String(value || '').toLowerCase().replace(/[^a-z0-9-]/g, '-');
}

function safeLink(value) {
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:') return '';
    return `<a class="secondary-button button-link" href="${escapeHtml(url.href)}" target="_blank" rel="noopener noreferrer">Open provider portal</a>`;
  } catch { return ''; }
}

export function setStatus(root, message, tone = '') {
  root.className = `status ${tone ? `status--${tone}` : ''}`;
  root.textContent = message;
}

function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;').replaceAll("'", '&#039;');
}
